import { SearchableFilter } from './searchable-filter'

export type CoTElement = {
    count: number
    selected: boolean
}

export type ChannelOfTradeDict = Record<string, CoTElement>

export class ChannelOfTradeFilters extends SearchableFilter {
    selectedChannelOfTrade: Set<string>
    id: string
    title: string
    fuseEngine: any
    viewAllVisible: boolean
    searchableFilter: ChannelOfTradeDict
    searchedFilter: ChannelOfTradeDict
    searchValue: string
    getSearchableFilter = () =>
        Object.keys(this.searchedFilter).length > 0
            ? this.searchedFilter
            : this.searchableFilter
    isPanelCollapsed: boolean
    selectAllSelected: boolean

    constructor(data?: any) {
        super()

        this.selectedChannelOfTrade = new Set()
        this.id = 'channel_of_trade'
        this.title = ''
        this.fuseEngine = null
        this.viewAllVisible = true
        this.searchableFilter = data
        this.searchedFilter = data
        this.searchValue = ''
        this.isPanelCollapsed = true
        this.selectAllSelected = false
    }
}
